const Question = ({
  question,
  currentQuestion,
  totalQuestions,
  selectedAnswer,
  onAnswerSelect,
  onNext,
  onPrevious,
  progress,
  isLastQuestion,
}) => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-dark-purple">
          Question {currentQuestion + 1} of {totalQuestions}
        </h2>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-4 mb-6">
        <div
          className="bg-dark-purple h-4 rounded-full transition-all duration-300"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      <p className="text-lg text-gray-800 mb-4 leading-relaxed">
        {question.question}
      </p>
      <p className="text-md text-gray-600 mb-6 italic">
        {question.description}
      </p>
      <div className="space-y-4 mb-6">
        {question.options.map((option, index) => (
          <button
            key={index}
            onClick={() => onAnswerSelect(option)}
            className={`w-full text-left p-4 border-2 border-gray-300 rounded-lg ${
              selectedAnswer === option ? 'bg-green-selected text-white' : 'bg-white'
            } ${
              selectedAnswer === option ? 'hover:bg-green-hover' : 'hover:bg-gray-50'
            } text-gray-700 font-medium transition-colors duration-200`}
          >
            {option}
          </button>
        ))}
      </div>
      <div className="flex space-x-4">
        <button
          onClick={onPrevious}
          className="flex-1 px-6 py-3 rounded-lg bg-gray-300 text-gray-700 font-semibold hover:bg-gray-400 transition-colors duration-200"
          disabled={currentQuestion === 0}
        >
          Previous
        </button>
        <button
          onClick={onNext}
          disabled={!selectedAnswer}
          className={`flex-1 px-6 py-3 rounded-lg text-white font-semibold ${
            selectedAnswer ? 'bg-dark-purple hover:bg-opacity-90' : 'bg-gray-disabled cursor-not-allowed'
          } transition-all duration-200`}
        >
          {isLastQuestion ? 'Submit' : 'Next'}
        </button>
      </div>
    </div>
  );
};

export default Question;